import * as React from "react";
import {Icon} from "../../../Components/Icons/Icon";

interface ILogoProps {
    logo: string;
}

export const Logo = ({logo}: ILogoProps) => <Icon file={logo} style={{maxWidth: 200, maxHeight: 200}} abosolutePath={true} />;
